import { jsx as _jsx } from "react/jsx-runtime";
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import { theme } from '../../themes/theme';
export const ThemeProvider = ({ children }) => (_jsx(MuiThemeProvider, Object.assign({ theme: theme }, { children: children })));
